// core
import React, { useContext } from "react";
import Layout from "../../components/Layout/Layout";
import { QuoteGroupContext } from "../../providers/RootContextProvider";
import styles from "./ProductPage.module.scss";
import cx from "classnames";
import QuoteSettingSidebar from "../../components/Quotes/Components/QuoteSettingSidebar/QuoteSettingSidebar";
import ProductPageQuotes from "./Sections/ProductPageQuotes/ProductPageQuotes";
import QuoteLoaderWrapper from "../../components/QuoteLoaderWrapper/QuoteLoaderWrapper";
import Icon from "../../../common/components/Icon/Icon";

const ProductPage: React.FC = () => {
    const { selectors } = useContext(QuoteGroupContext);

    const groupId = selectors.getGroupId();

    return (
        <QuoteLoaderWrapper>
            <Layout progressBarCurrentStage={"compare"}>
                {selectors.hasDigitalAdviceResult() && !selectors.isLoadingQuoteResult() && (
                    <a
                        href={selectors.getDigitalAdviceURL()}
                        className={cx(
                            "layout-flex-row--centered",
                            styles["dap-back-button"]
                        )}>
                        <Icon id="ChevronBackLarge" size="l"></Icon>Back
                    </a>
                )}
                <div className={cx("layout-flex-row", "flex-gap-l")}>
                    <QuoteSettingSidebar
                        settings={selectors.getAllSettings()}
                        className={styles["product-settings-container"]}
                        isLoading={selectors.isLoadingQuoteResult()}
                    />

                    <ProductPageQuotes
                        className={cx(styles["product-quotes-container"])}
                        groupId={groupId}
                        clients={selectors.getClients()}
                        cards={selectors.getQuoteResults()}
                    />
                </div>
            </Layout>
        </QuoteLoaderWrapper>
    );
};

ProductPage.displayName = "Multi Product Page";

export default React.memo(ProductPage);
